import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "50",
  viewBox: "0 0 50 50",
  ...extra,
  children: [/*#__PURE__*/_jsx("path", {
    d: "M25 0C11.23 0 0 11.23 0 25c0 12.043 9.553 25 25 25 13.77 0 25-11.23 25-25S38.77 0 25 0zm-3.81 34.197l-6.962-6.96 2.49-2.49 4.42 4.42L33.23 17.073l2.49 2.49-14.53 14.632z"
  }), title]
});